import type { BundleInfo } from '../types/BundleInfo.js';

/**
 * Get the set of dependencies consumed by the given bundle info.
 * @param info - The bundle info.
 * @returns The deduplicated set of dependencies consumed by the given bundle info.
 */
export function getConsumedDependencies(info: BundleInfo): Set<string> {
  const consumedDependencies = new Set<string>();
  // Iterate through imports and find their path from the resolve map.
  for (const entryInfo of Object.values(info)) {
    if (!entryInfo) {
      continue; // This is to make type-checking happy
    }
    // iterate through all package names of result.info.consumes
    for (const consume of entryInfo.consumes) {
      consumedDependencies.add(consume.packageName);
    }
  }

  return consumedDependencies;
}
